import React, { FC, ComponentProps as CP } from 'react'
import { Hidden } from '@material-ui/core'

import SortablePlayerList from 'components/SortablePlayerList'

import SplitPlayerList from './SplitPlayerList'

type Props = CP<typeof SortablePlayerList>

const ClassicGamePlayerList: FC<Props> = props => {
  return (
    <>
      <Hidden mdUp>
        <SortablePlayerList {...props} />
      </Hidden>

      <Hidden smDown>
        <SplitPlayerList {...props} />
      </Hidden>
    </>
  )
}

export default ClassicGamePlayerList
try {
    // @ts-ignore
    ClassicGamePlayerList.displayName = "ClassicGamePlayerList";
    // @ts-ignore
    ClassicGamePlayerList.__docgenInfo = { "description": "", "displayName": "ClassicGamePlayerList", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/TeamEditor/components/ClassicGamePlayerList.tsx#ClassicGamePlayerList"] = { docgenInfo: ClassicGamePlayerList.__docgenInfo, name: "ClassicGamePlayerList", path: "src/components/TeamEditor/components/ClassicGamePlayerList.tsx#ClassicGamePlayerList" };
}
catch (__react_docgen_typescript_loader_error) { }